/** Rótulos em português para valores vindos da API (roles, idiomas). */

const ROLE_LABELS: Record<string, string> = {
  ROLE_USER: "Usuário",
  USER: "Usuário",
  ROLE_ADMIN: "Administrador",
  ADMIN: "Administrador",
  ROLE_SUPER: "Superusuário",
  SUPER: "Superusuário",
  ROLE_REPORT: "Relatórios",
  REPORT: "Relatórios",
  ROLE_ACCESS_AUDIO: "Acesso a áudio",
  ACCESS_AUDIO: "Acesso a áudio",
  ROLE_DOWNLOAD_AUDIO: "Download de áudio",
  DOWNLOAD_AUDIO: "Download de áudio",
  ROLE_FORCE_LOGOUT: "Forçar logout",
  FORCE_LOGOUT: "Forçar logout",
};

const LANGUAGE_LABELS: Record<string, string> = {
  en: "Inglês",
  "pt-br": "Português (Brasil)",
  pt: "Português",
  es: "Espanhol",
};

export function formatRoleLabel(roleName: string): string {
  if (ROLE_LABELS[roleName]) return ROLE_LABELS[roleName];
  const bare = roleName.replace(/^ROLE_/, "");
  if (ROLE_LABELS[bare]) return ROLE_LABELS[bare];
  return bare.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
}

export function formatLanguageLabel(code: string): string {
  const key = code.toLowerCase();
  return LANGUAGE_LABELS[key] ?? code;
}
